import src from "IMAGE";
export default { src, width: 16, height: 4, blurWidth: 0, blurHeight: 0};
